import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../contexts/LanguageContext";

export default function Stats() {
  const { t } = useLang();
  const items = [
    { v: "200+", l: t.stats.a },
    { v: "5", l: t.stats.b },
    { v: "70%", l: t.stats.c },
    { v: "4.9★", l: t.stats.d },
  ];
  return (
    <section className="bg-white border-y border-slate-200" data-testid="stats-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12 py-10 md:py-14 grid grid-cols-2 md:grid-cols-4 gap-6">
        {items.map((s, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.07 }}
            className="text-center md:text-left"
            data-testid={`stat-${i}`}
          >
            <div className="font-display text-4xl md:text-5xl font-bold text-slate-950 tracking-tight">
              {s.v}
            </div>
            <div className="text-sm text-slate-500 mt-1.5">{s.l}</div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
